import React from "react";

// import router
import { Redirect } from "react-router-dom";

// Home
import Home from "../pages/home/Home";

// Opportunities
import Opportunities from "../pages/opportunities/Opportunities";
import Opportunity from "../pages/opportunities/Opportunity";
import NewOpportunities from "../pages/opportunities/NewOpportunity";
import OpportunityVerification from "../pages/opportunities/OpportunityVerification";

// Articles
import Article from "../pages/articles/Article";
import Articles from "../pages/articles/Articles";
import NewArticlePage from "../pages/articles/NewArticlePage";

// Countries
import Countries from "../pages/countries/Countries";
import Country from "../pages/countries/Country";
import FormationPage from "../pages/formations/FormationPage";

// Schools
import Schools from "../pages/schools/Schools";
import School from "../pages/schools/School";
import ApplyToSchool from "../pages/schools/ApplyToSchool";

// Domains
import Domains from "../pages/domains/Domains";
import Domain from "../pages/domains/Domain";

// Formations
import Formation from "../pages/formations/Formation";
import Formations from "../pages/formations/Formations";

// Authentification
import Login from "../pages/authentification/Login";
import Register from "../pages/authentification/Register";

// Dashboard
import Dashboard from "../pages/dashbaord/Dashboard";
import Favorites from "../pages/dashbaord/Favorites";
import StudentOffers from "../pages/dashbaord/StudentOffers";
import UserGeneralInformation from "../pages/userProfile/UserGeneralInformation";
import UserBiographicInformation from "../pages/userProfile/UserBiographicInformation";
import UserAcademicInformation from "../pages/userProfile/UserAcademicInformation";
import UserProfessionalInformation from "../pages/userProfile/UserProfessionalInformation";

// Searches
import Searches from "../pages/searches/Searches";
import ApplyToCheck from "../pages/dashbaord/ApplyToCheck";
import NewSearches from "../pages/searches/NewSarches";
import NewArticle from "../pages/articles/NewArticle";

// Private routes
// const protectedRoutes = [
//   { path: "/account", component: Dashboard },
//   { path: "/account/apply", component: ApplyToCheck },
// ];

const protectedRoutes = [
  { path: "/account", component: Dashboard },
  { path: "/favorites", component: Favorites },
  { path: "/student-offers", component: StudentOffers },
];

const userRoutes = [
  { path: "/user-general-information", component: UserGeneralInformation },
  {
    path: "/user-biographic-information",
    component: UserBiographicInformation,
  },
  { path: "/user-academic-information", component: UserAcademicInformation },
  {
    path: "/user-professional-information",
    component: UserProfessionalInformation,
  },
];

// Public routes
const publicRoutes = [
  // { path: "/articles/:articleCode", component: Article },
  // { path: "/articles", component: Articles },
  { path: "/articles", component: NewArticle },
  { path: "/articles/:code", component: NewArticlePage },
  // { path: "/new-article", component:NewArticle },

  { path: "/opportunites/:opportunityCode", component: Opportunity },
  // { path: "/opportunites", component: Opportunities },
  { path: "/opportunites", component: NewOpportunities },
  { path: "/opportunites/eligibities/:opportunityCode", component: OpportunityVerification },

  { path: "/pays/:countryCode", component: Country },
  { path: "/pays/regions/:regionCode", component: Countries },
  { path: "/country", component: Country },

  { path: "/etablissements/:schoolCode/apply", component: ApplyToSchool },
  { path: "/etablissements/:schoolCode", component: School },
  { path: "/etablissements", component: Schools },

  { path: "/formations/:formationCode", component: FormationPage },
  // { path: "/formations/:formationCode", component: Formation },
  { path: "/formations", component: Formations },

  { path: "/domaines/:domainCode", component: Domain },
  { path: "/domaines", component: Domains },

  { path: "/old-searches", component: Searches },
  { path: "/searches", component: NewSearches },

  { path: "/login", component: Login },
  { path: "/register", component: Register },

  // this route should be at the end of all other routes
  { path: "/", component: Home },
];

export { protectedRoutes, publicRoutes, userRoutes };
